import { render, staticRenderFns } from "./UploadFiles.vue?vue&type=template&id=e079d8f6&scoped=true"
import script from "./UploadFiles.vue?vue&type=script&lang=js"
export * from "./UploadFiles.vue?vue&type=script&lang=js"
import style0 from "./UploadFiles.vue?vue&type=style&index=0&id=e079d8f6&prod&lang=css"
import style1 from "./UploadFiles.vue?vue&type=style&index=1&id=e079d8f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e079d8f6",
  null
  
)

export default component.exports